import { useEffect } from "react";

import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import { useCRMIntegrationStatusQuery } from "app/pages/sales-intelligence/modules/manage-integrations/query/queries/useCRMIntegrationStatusQuery";
import extractCRMData from "app/pages/sales-intelligence/modules/manage-integrations/utils/extractCRMDataOrPlaceholder";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

export function useGatewayCrmAutoRedirect(integrationName: CrmIntegrationProvider): void {
    const crmStatusQuery = useCRMIntegrationStatusQuery(integrationName);

    useEffect(() => {
        if (crmStatusQuery.isLoading) {
            return;
        }

        const { isIntegrated } = extractCRMData(crmStatusQuery.data);

        if (isIntegrated) {
            void siNavigator.goToCrmManagementPage({ crm: integrationName });
        }
    }, [integrationName, crmStatusQuery.isLoading, crmStatusQuery.data]);
}
